/**
 * Tenant-specific contact information for the Dealership Workforce Study
 * Returns contact info based on the tenant (NADA, CADA, ATD)
 */

type Tenant = "nada" | "cada" | "atd";

interface ContactInfo {
    email: string;
    phone: string;
    phoneDisplay: string;
    phoneLink: string;
}

interface ExternalLinks {
    orgWebsite: string;
    dwsDatabase: string;
    aboutEsiq: string;
}

export const getContactInfo = (tenant: Tenant): ContactInfo => {
    switch (tenant) {
        case "cada":
            return {
                email: "cadasupport@esiq.ai",
                phone: "800.463.5289",
                phoneDisplay: "800.463.5289",
                phoneLink: "tel:+18004635289",
            };
        case "atd":
            return {
                email: "WorkforceStudy@atd.org",
                phone: "800.252.6232",
                phoneDisplay: "800.252.6232",
                phoneLink: "tel:+18002526232",
            };
        case "nada":
        default:
            return {
                email: "WorkforceStudy@nada.org",
                phone: "800.557.6232",
                phoneDisplay: "800.557.6232",
                phoneLink: "tel:+18005576232",
            };
    }
};

export const getCustomerServiceEmail = (tenant: Tenant): string => {
    switch (tenant) {
        case "cada":
            return "customerservice@cada.ca";
        case "atd":
            return "customerservice@atd.org";
        case "nada":
        default:
            return "customerservice@nada.org";
    }
};

export const getExternalLinks = (tenant: Tenant): ExternalLinks => {
    switch (tenant) {
        case "cada":
            return {
                orgWebsite: "https://cada.ca",
                dwsDatabase: "https://dashboard.cadaworkforcestudy.com",
                aboutEsiq: "https://esiq.ai",
            };
        case "atd":
            return {
                orgWebsite: "https://www.nada.org/atd/research/atd-dealership-workforce-study",
                dwsDatabase: "https://dashboard.atdworkforcestudy.com",
                aboutEsiq: "https://esiq.ai",
            };
        case "nada":
        default:
            return {
                orgWebsite:
                    "https://www.nada.org/nada/research-data/nada-dealership-workforce-study",
                dwsDatabase: "https://dashboard.nadaworkforcestudy.com",
                aboutEsiq: "https://esiq.ai",
            };
    }
};

// Legacy exports for backward compatibility (defaults to NADA)
export const CONTACT_INFO = getContactInfo("nada");
export const CUSTOMER_SERVICE = { email: getCustomerServiceEmail("nada") };
export const EXTERNAL_LINKS = getExternalLinks("nada");
